import React from 'react'
import useForm from 'react-hook-form'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import { Typography, TextField } from '@material-ui/core'
import Divider from '@material-ui/core/Divider'

import schema from '../../schemas'

const disableSchema = schema.disableSchema

const ContractDisable = ({ contractId, onEvent = () => {} }) => {
  const { handleSubmit, register, errors } = useForm({
    validationSchema: disableSchema,
  })
  const snackbar = useSnackbar()
  const [confirm, setConfirm] = React.useState(false)

  const onSubmit = async inactivation => {
    try {
      await service.recurrence.contracts.inactivate({
        contractId,
        observation: inactivation.observation,
      })

      snackbar.open({
        message: 'Assinatura inativida com sucesso!',
        variant: 'success',
      })

      onEvent()
      setConfirm(false)
    } catch (error) {
      snackbar.open({
        message: 'Erro ao inativar assinatura!',
        variant: 'error',
      })
    }
  }

  return (
    <>
      <Paper>
        <Box p={2}>
          <Typography variant="h4">Inativar assinatura</Typography>
        </Box>
        <Divider />
        <Box p={2}>
          <Typography gutterBottom color="textSecondary">
            Ao confirmar a inativação da assinatura, ela será encerrada e as
            cobranças posteriores não serão enviadas.
          </Typography>
          <Button
            onClick={() => {
              setConfirm(true)
            }}
            color="primary"
            variant="outlined"
          >
            Inativar
          </Button>
        </Box>
      </Paper>

      <Dialog open={confirm} onClose={() => setConfirm(false)}>
        <DialogTitle id="form-dialog-title">Inativar assinatura?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Atenção! Ao inativar a assinatura, ela não poderá ser reativada
            posteriormente. Para prosseguir com a inativação, por favor digite
            'Confirmar'.
          </DialogContentText>
          <form
            id="inactivation-contract-form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <TextField
              autoFocus
              name="observation"
              margin="dense"
              label="Motivo da inativação"
              inputRef={register}
              error={errors.observation !== undefined}
              helperText={errors.observation ? errors.observation.message : ''}
              fullWidth
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => setConfirm(false)}
          >
            Cancelar
          </Button>
          <Button
            form="inactivation-contract-form"
            type="submit"
            variant="contained"
            color="primary"
          >
            Inativar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ContractDisable
